<template>
  <v-card class="rounded-lg white">
    <v-card-title style="font-size: small" class="success--text">
      <v-img class="ml-2" max-height="15" max-width="15" src="/img/icons/factor.svg"></v-img>
      {{ title }}
      <v-spacer></v-spacer>
       <v-autocomplete
            label="وضعیت پرداخت"
            class="rounded-lg"
            :return-object="false"
            :items="paid_types"
            v-model="filters.is_paid"
            item-text="name"
            item-value="value"
            clearable
        />
    </v-card-title>
    <v-card-text>
      <m-datatable :show-filter-row="false" :headers="headers"
                   :show-select="false"
                   :apiUrl="url" :filters.sync="filters" ref="datatable">
        <template v-slot:item.created_at="{ item }">
          {{ format_date(item.created_at) }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ format_time(item.created_at) }}
        </template>
        <template v-slot:item.is_paid="{ item }">
          <span v-if="item.is_paid" class="success--text font-weight-bold">موفق</span>
          <span v-else class="error--text font-weight-bold">ناموفق</span>
        </template>
        <template #item.actions="{ item }">
          <v-btn depressed class="rounded-lg" color="primary white--text"
                 :to="{ name: 'SubscriptionFactorDetail', params: { id: item.id } }"
          >
            <v-icon class="white--text ml-2">fa-eye</v-icon>
            مشاهده جزئیات
          </v-btn
          >
        </template>
      </m-datatable>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: "SubscriptionsFactorsList",
  data() {
    return {
      paid_types: [
        {name: 'همه ی پرداخت ها', value: null},
        {name: 'پرداخت های موفق', value: true},
        {name: 'پرداخت های ناموفق', value: false},
      ],
      filters: {
        is_paid: null
      },
    };
  },
  computed: {
    url() {
      return "subscriptions/factors";
    },
    title() {
      return this.setDocumentTitle("پرداخت ها");
    },
    headers() {
      let headers = [
        {
          text: "شناسه یکتا",
          value: "id",
        },
        {
          text: "تاریخ",
          value: "created_at",
          type: "date",
        },
        {
          text: "ساعت",
          value: "time",
          type: "time",
        },
        {
          text: "مبلغ",
          value: "amount",
          type: 'numeric'
        },
        {
          text: "مبلغ تخفیف",
          value: "discount_amount",
          type: 'numeric'
        },
        {
          text: "مبلغ پس از تخفیف",
          value: "after_discount_amount",
          type: 'numeric',
        },
        {
          text: "مالیات ارزش افزوده",
          value: "added_value_tax",
          type: 'numeric',
        },
        {
          text: "مبلغ نهایی",
          value: "payable_amount",
          type: 'numeric',
        },
        {
          text: "وضعیت پرداخت",
          value: "is_paid",
          filterable: false,
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          filterable: false,
          sortable: false,
        },
      ];

      return headers;
    },
  },
  methods: {
    format_date(value) {
      return moment(value).format("YYYY/MM/DD")
    },
    format_time(value) {
      return moment(value).format("HH:mm")
    },
  },
};
</script>

<style scoped lang="scss"></style>
